export const topBarList = [
    // {
    //     id:0,
    //     label: '工作台'
    // },
    // {
    //     id:1,
    //     label: '挂号预约'
    // },
    // {
    //     id:2,
    //     label: '门诊'
    // },
    // {
    //     id:3,
    //     label: '收费'
    // },
    // {
    //     id:4,
    //     label: '药房'
    // },
    // {
    //     id:5,
    //     label: '执行'
    // },
    // {
    //     id:6,
    //     label: '检查'
    // },
    // {
    //     id:7,
    //     label: '检验'
    // },
    // {
    //     id:8,
    //     label: '库存'
    // },
    // {
    //     id:9,
    //     label: '患者'
    // },
    // {
    //     id:10,
    //     label: '医保'
    // },
    // {
    //     id:11,
    //     label: '统计'
    // },

]
export const nationalityList = [
    { id: 0, label: '汉族' },
    { id: 1, label: '蒙古族' },
    { id: 2, label: '回族' },
    { id: 3, label: '藏族' },
    { id: 4, label: '维吾尔族' },
    { id: 5, label: '苗族' },
    { id: 6, label: '彝族' },
    { id: 7, label: '壮族' },
    { id: 8, label: '布依族' },
    { id: 9, label: '朝鲜族' },
    { id: 10, label: '满族' },
    { id: 11, label: '侗族' },
    { id: 12, label: '瑶族' },
    { id: 13, label: '白族' },
    { id: 14, label: '土家族' },
    { id: 15, label: '哈尼族' },
    { id: 16, label: '哈萨克族' },
    { id: 17, label: '傣族' },
    { id: 18, label: '黎族' },
    { id: 19, label: '傈僳族' },
    { id: 20, label: '佤族' },
    { id: 21, label: '畲族' },
    { id: 22, label: '高山族' },
    { id: 23, label: '拉祜族' },
    { id: 24, label: '水族' },
    { id: 25, label: '东乡族' },
    { id: 26, label: '纳西族' },
    { id: 27, label: '景颇族' },
    { id: 28, label: '柯尔克孜族' },
    { id: 29, label: '土族' },
    { id: 30, label: '达斡尔族' },
    { id: 31, label: '仫佬族' },
    { id: 32, label: '羌族' },
    { id: 33, label: '布朗族' },
    { id: 34, label: '撒拉族' },
    { id: 35, label: '毛南族' },
    { id: 36, label: '仡佬族' },
    { id: 37, label: '锡伯族' },
    { id: 38, label: '阿昌族' },
    { id: 39, label: '普米族' },
    { id: 40, label: '塔吉克族' },
    { id: 41, label: '怒族' },
    { id: 42, label: '乌孜别克族' },
    { id: 43, label: '俄罗斯族' },
    { id: 44, label: '鄂温克族' },
    { id: 45, label: '德昂族' },
    { id: 46, label: '保安族' },
    { id: 47, label: '裕固族' },
    { id: 48, label: '京族' },
    { id: 49, label: '塔塔尔族' },
    { id: 50, label: '独龙族' },
    { id: 51, label: '鄂伦春族' },
    { id: 52, label: '赫哲族' },
    { id: 53, label: '门巴族' },
    { id: 54, label: '珞巴族' },
    { id: 55, label: '基诺族' }
]
export const maritalStatusList = [
    {id:0, label: '未婚'},
    {id:1, label: '已婚'},
    {id:2, label: '离异'},
    {id:3, label: '丧偶'},
]
export const careerList = [
    {id:0, label: '职员'},
    {id:1, label: '学生'},
    {id:2, label: '教师'},
    {id:3, label: '工人'},
    {id:4, label: '民工'},
    {id:5, label: '农民'},
    {id:6, label: '警察'},
    {id:7, label: '医务人员'},
    {id:8, label: '疾控人员'},
    {id:9, label: '动物检疫人员'},
    {id:10, label: '边境检疫人员'},
    {id:11, label: '流行病学调查员'},
    {id:12, label: '公共卫生专家'},
    {id:13, label: '销售'},
    {id:14, label: '律师'},
    {id:15, label: '军人'},
    {id:16, label: '离退人员'},
    {id:17, label: '公务员'},
    {id:18, label: '餐饮食品服务人员'},
    {id:19, label: '公共场所服务人员'},
    {id:20, label: '商业服务员'},
    {id:21, label: '海关关务人员'},
    {id:22, label: '旅游服务人员'},
    {id:23, label: '交通运输人员'},
    {id:24, label: '工程师'},
    {id:25, label: '牧民'},
    {id:26, label: '渔(船)民'},
    {id:27, label: '海员及长途驾驶员'},
    {id:28, label: '保育员及保姆'},
    {id:29, label: '幼托儿童'},
    {id:30, label: '散居儿童'},
    {id:31, label: '专业技术人员'},
    {id:32, label: '企业管理员'},
    {id:33, label: '个体经营'},
    {id:34, label: '无业人员'},
    {id:35, label: '自由职业'},
    {id:36, label: '家务及待业'},
    {id:37, label: '其它职业'}
]
export const doctorList = [
    {id:1,label:'王鑫月'},
    {id:2,label:'李德国'},
]
//主诉字典
export const zsSelectList = [
    [
        {
            typeTitle: null,
            list:['咳嗽','干咳','咳痰','夜咳','晨咳','咽干','咽痒','咽痛','痰中带血','声音嘶哑','咽部异物感','反复感冒','发热','喷嚏','流涕','鼻塞','头痛','头晕','耳鸣','汗多','盗汗','自汗','头汗','易汗出']
        },
    ],
    [
        {
            typeTitle: null,
            list:['胃胀','胃痛','胃不适','腹胀','腹痛','腹泻','恶心','呕吐','反酸','嗳气','烧心','纳差','便秘','便溏','便血','黑便','大便干','大便黏','五更泻','腹痛欲便','里急后重','排便不爽','溏结不调']
        },
    ],
    [
        {
            typeTitle: null,
            list:['胸闷','胸痛','心悸','气短','气喘','气促','眠差','眠浅','多梦','易醒','早醒','入睡困难','嗜睡','尿频','尿急','尿痛','尿不尽','尿灼热','尿分叉','夜尿多','尿浊','尿血','水肿','阳痿','遗精','早泄']
        },
    ],
    [
        {
            typeTitle: null,
            list:['肩痛','胁痛','背痛','腰痛','颈椎痛','关节痛','关节僵硬','四肢麻木','半身麻木','四肢无力','偏瘫','拘挛','眼干','口干','口苦','牙痛','齿衄','口疮','皮疹','斑疹','丘疹','风团','皮红斑','皮肤瘙痒']
        },
    ],
    [
        {
            typeTitle: null,
            list:['痛经','闭经','崩漏','月经量多','月经量少','月经提前','月经延后','经期错乱','带下量多','带下量少','带下异味','黄带']
        },
    ],
    [
        {
            typeTitle: null,
            list:['偶尔','1天','2天','3天','4天','5天','1周','2周','3周','1个月','2个月','3个月','半年','1年']
        }
    ],

]

// 现病史-已弃用
export const xbsSelectList = [
    [
        {
            typeTitle: '寒热',
            list:['恶风','恶寒','怕冷','发热','潮热','低热','手心热','脚心热','夜间发热','寒热往来']
        },
        {
            typeTitle: '汗出',
            list:['自汗','盗汗','汗多','汗黏','冷汗','头汗','背汗','手汗','脚汗']
        },
    ],
    [
        {
            typeTitle: '眠志',
            list:['眠可','眠差','眠浅','多梦','易醒','早醒','入睡困难','嗜睡','情绪正常','压力大','易怒','易躁','焦虑','抑郁','心烦']
        },
        {
            typeTitle: '饮食',
            list:['纳可','纳差','厌食','易饿','饥不欲食','口干','口苦','口淡','口黏','口干欲饮','渴不欲饮','喜冷饮','喜热饮']
        },
        {
            typeTitle: '二便',
            list:['小便正常','小便黄','小便清长','尿频','尿急','尿痛','|','大便正常','便溏','大便黏','大便干','完谷不化','溏结不调']
        },
    ]
]
// 寒热
export const hrSelectList = [
    [
        {
            typeTitle: null,
            list:['恶风','恶寒','怕冷','发热','潮热','低热','手心热','脚心热','夜间发热','寒热往来']
        },
    ],
]
// 汗出 {
export const hcSelectList = [
    [
        {
            typeTitle: null,
            list:['自汗','盗汗','汗多','汗黏','冷汗','头汗','背汗','手汗','脚汗']
        },
    ],
]
// 睡眠
export const mzSelectList = [
    [
        {
            typeTitle: null,
            list:['眠可','眠差','眠浅','多梦','易醒','早醒','入睡困难','嗜睡']
        },
    ],
]
// 情志
export const emotionSelectList = [
    [
        {
            typeTitle: null,
            list:['情绪正常','压力大','易怒','易躁','焦虑','抑郁','心烦']
        },
    ],
]
// 既往有
export const jwySelectList = [
    [
        {
            typeTitle: null,
            list:['高血压','高血脂','心脏病','糖尿病','痛风','精神疾病','脑梗死','肝炎','胃炎','肺结核','哮喘','鼻炎','甲亢','血液病']
        },
    ],
]
// 饮食
export const ysSelectList = [
    [
        {
            typeTitle: null,
            list:['纳可','纳差','厌食','易饿','饥不欲食','口干','口苦','口淡','口黏','口干欲饮','渴不欲饮','喜冷饮','喜热饮']
        },
    ],
]
// 小便
export const xbSelectList = [
    [
        {
            typeTitle: null,
            list:['小便正常','小便黄','小便清长','尿频','尿急','尿痛']
        },
    ],
]
// 大便
export const dbSelectList = [
    [
        {
            typeTitle: null,
            list:['大便正常','便溏','大便黏','大便干','完谷不化','溏结不调']
        },
    ],
]
// 经期
export const jqSelectList = [
    [
        {
            typeTitle: null,
            list:['经期正常','痛经','闭经','崩漏','月经量多','月经量少','月经提前','月经延后','经期错乱','带下量多','带下量少','带下异味','黄带', '绝经']
        },
    ],
]
// 体重
export const tzSelectList = {
    tizhong1: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'体重2.0kg',label: '2.0'},
                    {value:'体重2.5kg',label: '2.5'},
                    {value:'体重3.0kg',label: '3.0'},
                    {value:'体重3.5kg',label: '3.5'},
                    {value:'体重4.0kg',label: '4.0'},
                    {value:'体重4.5kg',label: '4.5'},
                    {value:'体重5.0kg',label: '5.0'},
                    {value:'体重5.5kg',label: '5.5'},
                    {value:'体重6.0kg',label: '6.0'},
                    {value:'体重6.5kg',label: '6.5'},
                    {value:'体重7.0kg',label: '7.0'},
                    {value:'体重7.5kg',label: '7.5'},
                    {value:'体重8.0kg',label: '8.0'},
                    {value:'体重8.5kg',label: '8.5'},
                    {value:'体重9.0kg',label: '9.0'},
                    {value:'体重9.5kg',label: '9.5'},
                    {value:'体重10.0kg',label: '10.0'},
                    {value:'体重10.5kg',label: '10.5'},
                    {value:'体重11.0kg',label: '11.0'},
                    {value:'体重11.5kg',label: '11.5'},
                    {value:'体重12.0kg',label: '12.0'},
                    {value:'体重12.5kg',label: '12.5'},
                    {value:'体重13.0kg',label: '13.0'},
                    {value:'体重13.5kg',label: '13.5'},
                    {value:'体重14.0kg',label: '14.0'},
                    {value:'体重14.5kg',label: '14.5'},
                    {value:'体重15.0kg',label: '15.0'},
                    {value:'体重15.5kg',label: '15.5'},
                    {value:'体重16.0kg',label: '16.0'},
                    {value:'体重16.5kg',label: '16.5'},
                    {value:'体重17.0kg',label: '17.0'},
                    {value:'体重17.5kg',label: '17.5'},
                    {value:'体重18.0kg',label: '18.0'},
                    {value:'体重18.5kg',label: '18.5'},
                    {value:'体重19.0kg',label: '19.0'},
                    {value:'体重19.5kg',label: '19.5'},
                    {value:'体重20.0kg',label: '20.0'},
                    {value:'体重20.5kg',label: '20.5'},
                    {value:'体重21.0kg',label: '21.0'},
                    {value:'体重21.5kg',label: '21.5'},
                    {value:'体重22.0kg',label: '22.0'},
                    {value:'体重22.5kg',label: '22.5'},
                    {value:'体重23.0kg',label: '23.0'},
                    {value:'体重23.5kg',label: '23.5'},
                    {value:'体重24.0kg',label: '24.0'},
                    {value:'体重24.5kg',label: '24.5'},
                    {value:'体重25.0kg',label: '25.0'},
                    {value:'体重25.5kg',label: '25.5'},
                    {value:'体重26.0kg',label: '26.0'},
                    {value:'体重26.5kg',label: '26.5'},
                    {value:'体重27.0kg',label: '27.0'},
                    {value:'体重27.5kg',label: '27.5'},
                    {value:'体重28.0kg',label: '28.0'},
                    {value:'体重28.5kg',label: '28.5'},
                    {value:'体重29.0kg',label: '29.0'},
                    {value:'体重29.5kg',label: '29.5'},
                    {value:'体重30.0kg',label: '30.0'},
                    {value:'体重30.5kg',label: '30.5'},
                    {value:'体重31.0kg',label: '31.0'},
                    {value:'体重31.5kg',label: '31.5'},
                    {value:'体重32.0kg',label: '32.0'},
                ]
            }
        ]
    ],
    tizhong2: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'体重30.0kg',label: '30.0'},
                    {value:'体重30.5kg',label: '30.5'},
                    {value:'体重31.0kg',label: '31.0'},
                    {value:'体重31.5kg',label: '31.5'},
                    {value:'体重32.0kg',label: '32.0'},
                    {value:'体重32.5kg',label: '32.5'},
                    {value:'体重33.0kg',label: '33.0'},
                    {value:'体重33.5kg',label: '33.5'},
                    {value:'体重34.0kg',label: '34.0'},
                    {value:'体重34.5kg',label: '34.5'},
                    {value:'体重35.0kg',label: '35.0'},
                    {value:'体重35.5kg',label: '35.5'},
                    {value:'体重36.0kg',label: '36.0'},
                    {value:'体重36.5kg',label: '36.5'},
                    {value:'体重37.0kg',label: '37.0'},
                    {value:'体重37.5kg',label: '37.5'},
                    {value:'体重38.0kg',label: '38.0'},
                    {value:'体重38.5kg',label: '38.5'},
                    {value:'体重39.0kg',label: '39.0'},
                    {value:'体重39.5kg',label: '39.5'},
                    {value:'体重40.0kg',label: '40.0'},
                    {value:'体重40.5kg',label: '40.5'},
                    {value:'体重41.0kg',label: '41.0'},
                    {value:'体重41.5kg',label: '41.5'},
                    {value:'体重42.0kg',label: '42.0'},
                    {value:'体重42.5kg',label: '42.5'},
                    {value:'体重43.0kg',label: '43.0'},
                    {value:'体重43.5kg',label: '43.5'},
                    {value:'体重44.0kg',label: '44.0'},
                    {value:'体重44.5kg',label: '44.5'},
                    {value:'体重45.0kg',label: '45.0'},
                    {value:'体重45.5kg',label: '45.5'},
                    {value:'体重46.0kg',label: '46.0'},
                    {value:'体重46.5kg',label: '46.5'},
                    {value:'体重47.0kg',label: '47.0'},
                    {value:'体重47.5kg',label: '47.5'},
                    {value:'体重48.0kg',label: '48.0'},
                    {value:'体重48.5kg',label: '48.5'},
                    {value:'体重49.0kg',label: '49.0'},
                    {value:'体重49.5kg',label: '49.5'},
                    {value:'体重50.0kg',label: '50.0'},
                    {value:'体重50.5kg',label: '50.5'},
                    {value:'体重51.0kg',label: '51.0'},
                    {value:'体重51.5kg',label: '51.5'},
                    {value:'体重52.0kg',label: '52.0'},
                    {value:'体重52.5kg',label: '52.5'},
                    {value:'体重53.0kg',label: '53.0'},
                    {value:'体重53.5kg',label: '53.5'},
                    {value:'体重54.0kg',label: '54.0'},
                    {value:'体重54.5kg',label: '54.5'},
                    {value:'体重55.0kg',label: '55.0'},
                    {value:'体重55.5kg',label: '55.5'},
                    {value:'体重56.0kg',label: '56.0'},
                    {value:'体重56.5kg',label: '56.5'},
                    {value:'体重57.0kg',label: '57.0'},
                    {value:'体重57.5kg',label: '57.5'},
                    {value:'体重58.0kg',label: '58.0'},
                    {value:'体重58.5kg',label: '58.5'},
                    {value:'体重59.0kg',label: '59.0'},
                    {value:'体重59.5kg',label: '59.5'},
                    {value:'体重60.0kg',label: '60.0'},
                ]
            }
        ]
    ],
    tizhong3: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'体重45kg',label: '45'},
                    {value:'体重46kg',label: '46'},
                    {value:'体重47kg',label: '47'},
                    {value:'体重48kg',label: '48'},
                    {value:'体重49kg',label: '49'},
                    {value:'体重50kg',label: '50'},
                    {value:'体重51kg',label: '51'},
                    {value:'体重52kg',label: '52'},
                    {value:'体重53kg',label: '53'},
                    {value:'体重54kg',label: '54'},
                    {value:'体重55kg',label: '55'},
                    {value:'体重56kg',label: '56'},
                    {value:'体重57kg',label: '57'},
                    {value:'体重58kg',label: '58'},
                    {value:'体重59kg',label: '59'},
                    {value:'体重60kg',label: '60'},
                    {value:'体重61kg',label: '61'},
                    {value:'体重62kg',label: '62'},
                    {value:'体重63kg',label: '63'},
                    {value:'体重64kg',label: '64'},
                    {value:'体重65kg',label: '65'},
                    {value:'体重66kg',label: '66'},
                    {value:'体重67kg',label: '67'},
                    {value:'体重68kg',label: '68'},
                    {value:'体重69kg',label: '69'},
                    {value:'体重70kg',label: '70'},
                    {value:'体重71kg',label: '71'},
                    {value:'体重72kg',label: '72'},
                    {value:'体重73kg',label: '73'},
                    {value:'体重74kg',label: '74'},
                    {value:'体重75kg',label: '75'},
                    {value:'体重76kg',label: '76'},
                    {value:'体重77kg',label: '77'},
                    {value:'体重78kg',label: '78'},
                    {value:'体重79kg',label: '79'},
                    {value:'体重80kg',label: '80'},
                    {value:'体重81kg',label: '81'},
                    {value:'体重82kg',label: '82'},
                    {value:'体重83kg',label: '83'},
                    {value:'体重84kg',label: '84'},
                    {value:'体重85kg',label: '85'},
                    {value:'体重86kg',label: '86'},
                    {value:'体重87kg',label: '87'},
                    {value:'体重88kg',label: '88'},
                    {value:'体重89kg',label: '89'},
                    {value:'体重90kg',label: '90'},
                    {value:'体重91kg',label: '91'},
                    {value:'体重92kg',label: '92'},
                    {value:'体重93kg',label: '93'},
                    {value:'体重94kg',label: '94'},
                    {value:'体重95kg',label: '95'},
                    {value:'体重96kg',label: '96'},
                    {value:'体重97kg',label: '97'},
                    {value:'体重98kg',label: '98'},
                    {value:'体重99kg',label: '99'},
                    {value:'体重100kg',label: '100'},
                ]
            }
        ]
    ]
}

// 身高
export const sgSelectList = {
    shengao1: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'身高45cm',label: '45'},
                    {value:'身高46cm',label: '46'},
                    {value:'身高47cm',label: '47'},
                    {value:'身高48cm',label: '48'},
                    {value:'身高49cm',label: '49'},
                    {value:'身高50cm',label: '50'},
                    {value:'身高51cm',label: '51'},
                    {value:'身高52cm',label: '52'},
                    {value:'身高53cm',label: '53'},
                    {value:'身高54cm',label: '54'},
                    {value:'身高55cm',label: '55'},
                    {value:'身高56cm',label: '56'},
                    {value:'身高57cm',label: '57'},
                    {value:'身高58cm',label: '58'},
                    {value:'身高59cm',label: '59'},
                    {value:'身高60cm',label: '60'},
                    {value:'身高61cm',label: '61'},
                    {value:'身高62cm',label: '62'},
                    {value:'身高63cm',label: '63'},
                    {value:'身高64cm',label: '64'},
                    {value:'身高65cm',label: '65'},
                    {value:'身高66cm',label: '66'},
                    {value:'身高67cm',label: '67'},
                    {value:'身高68cm',label: '68'},
                    {value:'身高69cm',label: '69'},
                    {value:'身高70cm',label: '70'},
                    {value:'身高71cm',label: '71'},
                    {value:'身高72cm',label: '72'},
                    {value:'身高73cm',label: '73'},
                    {value:'身高74cm',label: '74'},
                    {value:'身高75cm',label: '75'},
                    {value:'身高76cm',label: '76'},
                    {value:'身高77cm',label: '77'},
                    {value:'身高78cm',label: '78'},
                    {value:'身高79cm',label: '79'},
                    {value:'身高80cm',label: '80'},
                    {value:'身高81cm',label: '81'},
                    {value:'身高82cm',label: '82'},
                    {value:'身高83cm',label: '83'},
                    {value:'身高84cm',label: '84'},
                    {value:'身高85cm',label: '85'},
                    {value:'身高86cm',label: '86'},
                    {value:'身高87cm',label: '87'},
                    {value:'身高88cm',label: '88'},
                    {value:'身高89cm',label: '89'},
                    {value:'身高90cm',label: '90'},
                    {value:'身高91cm',label: '91'},
                    {value:'身高92cm',label: '92'},
                    {value:'身高93cm',label: '93'},
                    {value:'身高94cm',label: '94'},
                    {value:'身高95cm',label: '95'},
                    {value:'身高96cm',label: '96'},
                    {value:'身高97cm',label: '97'},
                    {value:'身高98cm',label: '98'},
                    {value:'身高99cm',label: '99'},
                    {value:'身高100cm',label: '100'},
                ]
            }
        ]
    ],
    shengao2: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'身高100cm',label: '100'},
                    {value:'身高101cm',label: '101'},
                    {value:'身高102cm',label: '102'},
                    {value:'身高103cm',label: '103'},
                    {value:'身高104cm',label: '104'},
                    {value:'身高105cm',label: '105'},
                    {value:'身高106cm',label: '106'},
                    {value:'身高107cm',label: '107'},
                    {value:'身高108cm',label: '108'},
                    {value:'身高109cm',label: '109'},
                    {value:'身高110cm',label: '110'},
                    {value:'身高111cm',label: '111'},
                    {value:'身高112cm',label: '112'},
                    {value:'身高113cm',label: '113'},
                    {value:'身高114cm',label: '114'},
                    {value:'身高115cm',label: '115'},
                    {value:'身高116cm',label: '116'},
                    {value:'身高117cm',label: '117'},
                    {value:'身高118cm',label: '118'},
                    {value:'身高119cm',label: '119'},
                    {value:'身高120cm',label: '120'},
                    {value:'身高121cm',label: '121'},
                    {value:'身高122cm',label: '122'},
                    {value:'身高123cm',label: '123'},
                    {value:'身高124cm',label: '124'},
                    {value:'身高125cm',label: '125'},
                    {value:'身高126cm',label: '126'},
                    {value:'身高127cm',label: '127'},
                    {value:'身高128cm',label: '128'},
                    {value:'身高129cm',label: '129'},
                    {value:'身高130cm',label: '130'},
                    {value:'身高131cm',label: '131'},
                    {value:'身高132cm',label: '132'},
                    {value:'身高133cm',label: '133'},
                    {value:'身高134cm',label: '134'},
                    {value:'身高135cm',label: '135'},
                    {value:'身高136cm',label: '136'},
                    {value:'身高137cm',label: '137'},
                    {value:'身高138cm',label: '138'},
                    {value:'身高139cm',label: '139'},
                    {value:'身高140cm',label: '140'},
                    {value:'身高141cm',label: '141'},
                    {value:'身高142cm',label: '142'},
                    {value:'身高143cm',label: '143'},
                    {value:'身高144cm',label: '144'},
                    {value:'身高145cm',label: '145'},
                    {value:'身高146cm',label: '146'},
                    {value:'身高147cm',label: '147'},
                    {value:'身高148cm',label: '148'},
                    {value:'身高149cm',label: '149'},
                    {value:'身高150cm',label: '150'},
                ]
            }
        ]
    ],
    shengao3: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'身高150cm',label: '150'},
                    {value:'身高151cm',label: '151'},
                    {value:'身高152cm',label: '152'},
                    {value:'身高153cm',label: '153'},
                    {value:'身高154cm',label: '154'},
                    {value:'身高155cm',label: '155'},
                    {value:'身高156cm',label: '156'},
                    {value:'身高157cm',label: '157'},
                    {value:'身高158cm',label: '158'},
                    {value:'身高159cm',label: '159'},
                    {value:'身高160cm',label: '160'},
                    {value:'身高161cm',label: '161'},
                    {value:'身高162cm',label: '162'},
                    {value:'身高163cm',label: '163'},
                    {value:'身高164cm',label: '164'},
                    {value:'身高165cm',label: '165'},
                    {value:'身高166cm',label: '166'},
                    {value:'身高167cm',label: '167'},
                    {value:'身高168cm',label: '168'},
                    {value:'身高169cm',label: '169'},
                    {value:'身高170cm',label: '170'},
                    {value:'身高171cm',label: '171'},
                    {value:'身高172cm',label: '172'},
                    {value:'身高173cm',label: '173'},
                    {value:'身高174cm',label: '174'},
                    {value:'身高175cm',label: '175'},
                    {value:'身高176cm',label: '176'},
                    {value:'身高177cm',label: '177'},
                    {value:'身高178cm',label: '178'},
                    {value:'身高179cm',label: '179'},
                    {value:'身高180cm',label: '180'},
                    {value:'身高181cm',label: '181'},
                    {value:'身高182cm',label: '182'},
                    {value:'身高183cm',label: '183'},
                    {value:'身高184cm',label: '184'},
                    {value:'身高185cm',label: '185'},
                    {value:'身高186cm',label: '186'},
                    {value:'身高187cm',label: '187'},
                    {value:'身高188cm',label: '188'},
                    {value:'身高189cm',label: '189'},
                    {value:'身高190cm',label: '190'},
                    {value:'身高191cm',label: '191'},
                    {value:'身高192cm',label: '192'},
                    {value:'身高193cm',label: '193'},
                    {value:'身高194cm',label: '194'},
                    {value:'身高195cm',label: '195'},
                    {value:'身高196cm',label: '196'},
                    {value:'身高197cm',label: '197'},
                    {value:'身高198cm',label: '198'},
                    {value:'身高199cm',label: '199'},
                    {value:'身高200cm',label: '200'},
                ]
            }
        ]
    ],
}
// 体征
export const tizhengSelectList = {
    tz: [
        [
            {
                typeTitle: null,
                list:['生命体征平稳','神志清楚','精神反应尚可','未见皮疹','浅表淋巴结未扪及肿大','双肺呼吸音清晰']
            },
            {
                typeTitle: null,
                list:['双肺叩诊呈清音','未闻及异常呼吸音及干湿啰音','未闻及心包摩擦音']
            },
            {
                typeTitle: null,
                list:['心前区无异常搏动','心音有力心律齐','各瓣膜区未闻及明显杂音']
            },
            {
                typeTitle: null,
                list:['腹部柔软','无腹肌紧张','全腹部无压痛','肠鸣音活跃','双肾区无叩痛']
            },
        ]
    ],
}
// 体温
export const tiwenSelectList = {
    tw: [
        [
            {
                typeTitle: null,
                list:[
                    {value:'体温36.0°C',label:'36.0°C'},
                    {value:'体温36.5°C',label:'36.5°C'},
                    {value:'体温37.0°C',label:'37.0°C'},
                    {value:'体温37.3°C',label:'37.3°C'},
                    {value:'体温37.4°C',label:'37.4°C'},
                    {value:'体温37.5°C',label:'37.5°C'},
                    {value:'体温37.6°C',label:'37.6°C'},
                    {value:'体温37.7°C',label:'37.7°C'},
                    {value:'体温37.8°C',label:'37.8°C'},
                    {value:'体温37.9°C',label:'37.9°C'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'体温38.0°C',label:'38.0°C'},
                    {value:'体温38.1°C',label:'38.1°C'},
                    {value:'体温38.2°C',label:'38.2°C'},
                    {value:'体温38.3°C',label:'38.3°C'},
                    {value:'体温38.4°C',label:'38.4°C'},
                    {value:'体温38.5°C',label:'38.5°C'},
                    {value:'体温38.6°C',label:'38.6°C'},
                    {value:'体温38.7°C',label:'38.7°C'},
                    {value:'体温38.8°C',label:'38.8°C'},
                    {value:'体温38.9°C',label:'38.9°C'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'体温39.0°C',label:'39.0°C'},
                    {value:'体温39.1°C',label:'39.1°C'},
                    {value:'体温39.2°C',label:'39.2°C'},
                    {value:'体温39.3°C',label:'39.3°C'},
                    {value:'体温39.4°C',label:'39.4°C'},
                    {value:'体温39.5°C',label:'39.5°C'},
                    {value:'体温39.6°C',label:'39.6°C'},
                    {value:'体温39.7°C',label:'39.7°C'},
                    {value:'体温39.8°C',label:'39.8°C'},
                    {value:'体温39.9°C',label:'39.9°C'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'体温40.0°C',label:'40.0°C'},
                    {value:'体温40.1°C',label:'40.1°C'},
                    {value:'体温40.2°C',label:'40.2°C'},
                    {value:'体温40.3°C',label:'40.3°C'},
                    {value:'体温40.4°C',label:'40.4°C'},
                    {value:'体温40.5°C',label:'40.5°C'},
                    {value:'体温40.6°C',label:'40.6°C'},
                    {value:'体温40.7°C',label:'40.7°C'},
                    {value:'体温40.8°C',label:'40.8°C'},
                    {value:'体温40.9°C',label:'40.9°C'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'体温41.0°C',label:'41.0°C'},
                    {value:'体温41.1°C',label:'41.1°C'},
                    {value:'体温41.2°C',label:'41.2°C'},
                    {value:'体温41.3°C',label:'41.3°C'},
                    {value:'体温41.4°C',label:'41.4°C'},
                    {value:'体温41.5°C',label:'41.5°C'},
                    {value:'体温41.6°C',label:'41.6°C'},
                    {value:'体温41.7°C',label:'41.7°C'},
                    {value:'体温41.8°C',label:'41.8°C'},
                    {value:'体温41.9°C',label:'41.9°C'},
                ]
            },
        ]
    ]
}
// 脉搏
export const maiboSelectList = {
    mb: [
        [
            {
                typeTitle: null,
                list:[
                    {value:'脉搏30bpm',label:'30'},
                    {value:'脉搏35bpm',label:'35'},
                    {value:'脉搏40bpm',label:'40'},
                    {value:'脉搏45bpm',label:'45'},
                    {value:'脉搏50bpm',label:'50'},
                    {value:'脉搏55bpm',label:'55'},
                    {value:'脉搏60bpm',label:'60'},
                    {value:'脉搏65bpm',label:'65'},
                    {value:'脉搏70bpm',label:'70'},
                    {value:'脉搏75bpm',label:'75'},
                    {value:'脉搏80bpm',label:'80'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'脉搏85bpm',label:'85'},
                    {value:'脉搏90bpm',label:'90'},
                    {value:'脉搏95bpm',label:'95'},
                    {value:'脉搏100bpm',label:'100'},
                    {value:'脉搏105bpm',label:'105'},
                    {value:'脉搏110bpm',label:'110'},
                    {value:'脉搏115bpm',label:'115'},
                    {value:'脉搏120bpm',label:'120'},
                    {value:'脉搏125bpm',label:'125'},
                    {value:'脉搏130bpm',label:'130'},
                    {value:'脉搏135bpm',label:'135'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'脉搏140bpm',label:'140'},
                    {value:'脉搏145bpm',label:'145'},
                    {value:'脉搏150bpm',label:'150'},
                    {value:'脉搏155bpm',label:'155'},
                    {value:'脉搏160bpm',label:'160'},
                    {value:'脉搏165bpm',label:'165'},
                    {value:'脉搏170bpm',label:'170'},
                    {value:'脉搏175bpm',label:'175'},
                    {value:'脉搏180bpm',label:'180'},
                ]
            },
        ]
    ]
}
// 呼吸
export const huxiSelectList = {
    hx: [
        [
            {
                typeTitle: null,
                list:[
                    {value:'呼吸10次/分',label:'10'},
                    {value:'呼吸11次/分',label:'11'},
                    {value:'呼吸12次/分',label:'12'},
                    {value:'呼吸13次/分',label:'13'},
                    {value:'呼吸14次/分',label:'14'},
                    {value:'呼吸15次/分',label:'15'},
                    {value:'呼吸16次/分',label:'16'},
                    {value:'呼吸17次/分',label:'17'},
                    {value:'呼吸18次/分',label:'18'},
                    {value:'呼吸19次/分',label:'19'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'呼吸20次/分',label:'20'},
                    {value:'呼吸21次/分',label:'21'},
                    {value:'呼吸22次/分',label:'22'},
                    {value:'呼吸23次/分',label:'23'},
                    {value:'呼吸24次/分',label:'24'},
                    {value:'呼吸25次/分',label:'25'},
                    {value:'呼吸26次/分',label:'26'},
                    {value:'呼吸27次/分',label:'27'},
                    {value:'呼吸28次/分',label:'28'},
                    {value:'呼吸29次/分',label:'29'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'呼吸30次/分',label:'30'},
                    {value:'呼吸31次/分',label:'31'},
                    {value:'呼吸32次/分',label:'32'},
                    {value:'呼吸33次/分',label:'33'},
                    {value:'呼吸34次/分',label:'34'},
                    {value:'呼吸35次/分',label:'35'},
                    {value:'呼吸36次/分',label:'36'},
                    {value:'呼吸37次/分',label:'37'},
                    {value:'呼吸38次/分',label:'38'},
                    {value:'呼吸39次/分',label:'39'},
                ]
            },
        ]
    ]
}
// 血压
export const xueyaSelectList = {
    xy: [
        [
            {
                typeTitle: '收缩压',
                list:['82','84','86','88','90','92','94','96','98','100','102','104','106','108','110','112','114','116','118','120','122','124','126','128','130','132','134','136','138','140','142','144','146','148','150','152','154','156','158','160','162','164','166','168','170','172','174','176','178','180']
            }
        ],
        [
            {
                typeTitle: '舒展压',
                list:['52','54','56','58','60','62','64','66','68','70','72','74','76','78','80','82','84','86','88','90','92','94','96','98','100','102','104','106','108','110']
            }
        ]
    ],
}
// 血氧
export const xueyangSelectList = [
    [
        {
            typeTitle: null,
            list:[
                {value:'血氧70%',label:'70'},
                {value:'血氧71%',label:'71'},
                {value:'血氧72%',label:'72'},
                {value:'血氧73%',label:'73'},
                {value:'血氧74%',label:'74'},
                {value:'血氧75%',label:'75'},
                {value:'血氧76%',label:'76'},
                {value:'血氧77%',label:'77'},
                {value:'血氧78%',label:'78'},
                {value:'血氧79%',label:'79'},
                {value:'血氧80%',label:'80'},
                {value:'血氧81%',label:'81'},
                {value:'血氧82%',label:'82'},
                {value:'血氧83%',label:'83'},
                {value:'血氧84%',label:'84'},
                {value:'血氧85%',label:'85'},
                {value:'血氧86%',label:'86'},
                {value:'血氧87%',label:'87'},
                {value:'血氧88%',label:'88'},
                {value:'血氧89%',label:'89'},
                {value:'血氧90%',label:'90'},
                {value:'血氧91%',label:'91'},
                {value:'血氧92%',label:'92'},
                {value:'血氧93%',label:'93'},
                {value:'血氧94%',label:'94'},
                {value:'血氧95%',label:'95'},
                {value:'血氧96%',label:'96'},
                {value:'血氧97%',label:'97'},
                {value:'血氧98%',label:'98'},
                {value:'血氧99%',label:'99'},
            ]
        },
    ],
]
// 血糖
export const xuetangSelectList = {
    xuetang:[
        [
            {
                typeTitle: null,
                list:[
                    {value:'血糖4.0mmol/L',label:'4.0'},
                    {value:'血糖4.1mmol/L',label:'4.1'},
                    {value:'血糖4.2mmol/L',label:'4.2'},
                    {value:'血糖4.3mmol/L',label:'4.3'},
                    {value:'血糖4.4mmol/L',label:'4.4'},
                    {value:'血糖4.5mmol/L',label:'4.5'},
                    {value:'血糖4.6mmol/L',label:'4.6'},
                    {value:'血糖4.7mmol/L',label:'4.7'},
                    {value:'血糖4.8mmol/L',label:'4.8'},
                    {value:'血糖4.9mmol/L',label:'4.9'},
                    {value:'血糖5.0mmol/L',label:'5.0'},
                    {value:'血糖5.1mmol/L',label:'5.1'},
                    {value:'血糖5.2mmol/L',label:'5.2'},
                    {value:'血糖5.3mmol/L',label:'5.3'},
                    {value:'血糖5.4mmol/L',label:'5.4'},
                    {value:'血糖5.5mmol/L',label:'5.5'},
                    {value:'血糖5.6mmol/L',label:'5.6'},
                    {value:'血糖5.7mmol/L',label:'5.7'},
                    {value:'血糖5.8mmol/L',label:'5.8'},
                    {value:'血糖5.9mmol/L',label:'5.9'},
                    {value:'血糖6.0mmol/L',label:'6.0'},
                    {value:'血糖6.1mmol/L',label:'6.1'},
                    {value:'血糖6.2mmol/L',label:'6.2'},
                    {value:'血糖6.3mmol/L',label:'6.3'},
                    {value:'血糖6.4mmol/L',label:'6.4'},
                    {value:'血糖6.5mmol/L',label:'6.5'},
                    {value:'血糖6.6mmol/L',label:'6.6'},
                    {value:'血糖6.7mmol/L',label:'6.7'},
                    {value:'血糖6.8mmol/L',label:'6.8'},
                    {value:'血糖6.9mmol/L',label:'6.9'},
                    {value:'血糖7.0mmol/L',label:'7.0'},
                    {value:'血糖7.1mmol/L',label:'7.1'},
                    {value:'血糖7.2mmol/L',label:'7.2'},
                    {value:'血糖7.3mmol/L',label:'7.3'},
                    {value:'血糖7.4mmol/L',label:'7.4'},
                    {value:'血糖7.5mmol/L',label:'7.5'},
                    {value:'血糖7.6mmol/L',label:'7.6'},
                    {value:'血糖7.7mmol/L',label:'7.7'},
                    {value:'血糖7.8mmol/L',label:'7.8'},
                    {value:'血糖7.9mmol/L',label:'7.9'},
                    {value:'血糖8.0mmol/L',label:'8.0'},
                    {value:'血糖8.1mmol/L',label:'8.1'},
                    {value:'血糖8.2mmol/L',label:'8.2'},
                    {value:'血糖8.3mmol/L',label:'8.3'},
                    {value:'血糖8.4mmol/L',label:'8.4'},
                    {value:'血糖8.5mmol/L',label:'8.5'},
                    {value:'血糖8.6mmol/L',label:'8.6'},
                    {value:'血糖8.7mmol/L',label:'8.7'},
                    {value:'血糖8.8mmol/L',label:'8.8'},
                    {value:'血糖8.9mmol/L',label:'8.9'},
                    {value:'血糖9.0mmol/L',label:'9.0'},
                    {value:'血糖9.1mmol/L',label:'9.1'},
                    {value:'血糖9.2mmol/L',label:'9.2'},
                    {value:'血糖9.3mmol/L',label:'9.3'},
                    {value:'血糖9.4mmol/L',label:'9.4'},
                    {value:'血糖9.5mmol/L',label:'9.5'},
                    {value:'血糖9.6mmol/L',label:'9.6'},
                    {value:'血糖9.7mmol/L',label:'9.7'},
                    {value:'血糖9.8mmol/L',label:'9.8'},
                    {value:'血糖9.9mmol/L',label:'9.9'},
                    {value:'血糖10.0mmol/L',label:'10.0'},
                    {value:'血糖10.2mmol/L',label:'10.2'},
                    {value:'血糖10.4mmol/L',label:'10.4'},
                    {value:'血糖10.6mmol/L',label:'10.6'},
                    {value:'血糖10.8mmol/L',label:'10.8'},
                    {value:'血糖11.0mmol/L',label:'11.0'},
                    {value:'血糖11.2mmol/L',label:'11.2'},
                    {value:'血糖11.4mmol/L',label:'11.4'},
                    {value:'血糖11.6mmol/L',label:'11.6'},
                    {value:'血糖11.8mmol/L',label:'11.8'},
                ]
            }
        ]
    ]
}
// 面诊
export const mianzhenSelectList = [
    [
        {
            typeTitle: null,
            list:['面色淡白','面色萎黄','面色晦暗','面色少华','面色青','面色红','目光乏神','精神不振']
        },
    ],
    ]
// 舌诊
export const shezhenSelectList = [
    [
        {
            typeTitle: '舌色',
            list:['舌淡红','舌淡白','舌色暗','舌红','舌尖红','舌边红','舌青紫','舌淡紫','舌绛']
        },
        {
            typeTitle: '舌形',
            list:['舌老','舌嫩','舌有齿痕','舌有裂纹','舌体胖大','舌体瘦小','舌有点刺','舌尖点刺','舌边点刺']
        },
        {
            typeTitle: '络脉',
            list:['络脉短','络脉细','络脉粗','络脉曲张','络脉暗红','络脉青紫','络脉分叉']
        },
        {
            typeTitle: '苔质',
            list:['苔薄','苔厚','苔滑','苔润','苔燥','苔腻','苔腐','苔剥落','少苔','无苔']
        },
        {
            typeTitle: '苔色',
            list:['苔白','苔黄','苔灰','苔黑']
        }
    ]
]
// 脉诊
export const maizhenSelectList = [
    [
        {
            typeTitle: '单脉',
            list:['脉浮','脉沉','脉弦','脉细','脉数','脉滑','脉迟','脉涩','脉弱','脉虚','脉濡','脉缓','脉紧','洪脉','实脉','促脉','代脉','动脉','短脉','伏脉','革脉','疾脉','结脉','芤脉','散脉','牢脉','微脉','长脉']
        },
        {
            typeTitle: '合脉',
            list:['脉沉细','脉沉迟','脉沉弱','脉细数','脉细弱','脉弦滑','脉弦细','脉弦数','脉滑数','脉浮数']
        }
    ]
]
export const jwsSelectList = [
    [
        {
            typeTitle: null,
            list:['既往体健','未见明显异常','无呛咳史']
        },
        {
            typeTitle: null,
            list:['否认药物过敏史','否认慢性疾病','否认传染病史','否认遗传病史','否认备孕','否认怀孕']
        },
    ],
    [
        {
            typeTitle: '既往有',
            list:['高血压','高血脂','心脏病','糖尿病','痛风','精神疾病','脑梗死','肝炎','胃炎','肺结核','哮喘','鼻炎','甲亢','血液病']
        },
        {
            typeTitle: '个人史',
            list:['吸烟','偶尔吸烟','长期吸烟','不饮酒','偶尔饮酒','长期饮酒','p','未婚','已婚','未孕','备孕','怀孕','闭经','有早产史','有流产史','有痛经史']
        }
    ]
]
export const jzsSelectList = [
    [
        {
            typeTitle: null,
            list:['否认家族遗传病史']
        },
    ],
    [
        {
            typeTitle: '家族有',
            list:[]
        },
        {
            typeTitle: '',
            list:['高血压','心脏病','糖尿病','慢性肝炎','脑出血','地中海贫血','肝癌','肺癌','胃癌','结肠癌','乳腺癌','皮肤癌','哮喘病','血友病','肥胖病','高度近视','白化病','唇裂','腭裂','精神分裂','抑郁症']
        }
    ]
]
export const gmsSelectList = [
    [
        {
            typeTitle: null,
            list:['否认药物过敏史','否认食物过敏史']
        },
    ],
    [
        {
            typeTitle: '过敏史',
            list:[]
        },
        {
            typeTitle: '',
            list:['青霉素','链霉菌','卡那霉素','左氧氟沙星','溴酚酸钠','阿托品','头孢类','磺胺类','酒精','碘伏','去痛片','扑热息痛','安痛定','安定','鲁米那','阿司匹林','普鲁卡因','花粉','霉菌','尘螨','毛发皮屑','牛奶','鸡蛋','大豆','小麦','花生','鱼虾','坚果']
        }
    ]
]

export const grsSelectList = [
    [
        {
            typeTitle: '',
            list:['否认疫区旅居史','否认传染病接触史','否认粉尘/毒物/放射性物质接触史','否认冶游史']
        },
        {
            typeTitle: '',
            list:['生活起居规律','饮食习惯均衡','无烟酒不良嗜好']
        },
        {
            typeTitle: '',
            list:['否认外伤及手术史','预防接种史不详']
        }
    ],
    [
        {
            typeTitle: '',
            list:['不吸烟','偶尔吸烟','长期吸烟','不饮酒','偶尔饮酒','长期饮酒']
        },
        {
            typeTitle: '',
            list:['未婚','已婚','未孕','有孕','闭经','有早产史','有流产史','有痛经史']
        }
    ]
]
// 望闻切诊-已弃用
export const wwqzSelectList = [
    [
        {
            typeTitle: '神色',
            list:['面色淡白','面色萎黄','面色晦暗','面色少华','面色青','面色红','目光乏神','精神不振']
        }
    ],
    [
        {
            typeTitle: '舌色',
            list:['舌淡红','舌淡白','舌色暗','舌红','舌尖红','舌边红','舌青紫','舌淡紫','舌绛']
        },
        {
            typeTitle: '舌形',
            list:['舌老','舌嫩','舌有齿痕','舌有裂纹','舌体胖大','舌体瘦小','舌有点刺','舌尖点刺','舌边点刺']
        },
        {
            typeTitle: '络脉',
            list:['络脉短','络脉细','络脉粗','络脉曲张','络脉暗红','络脉青紫','络脉分叉']
        }
    ],
    [
        {
            typeTitle: '苔质',
            list:['苔薄','苔厚','苔滑','苔润','苔燥','苔腻','苔腐','苔剥落','少苔','无苔']
        },
        {
            typeTitle: '苔色',
            list:['苔白','苔黄','苔灰','苔黑']
        }
    ],
    [
        {
            typeTitle: '单脉',
            list:['脉浮','脉沉','脉弦','脉细','脉数','脉滑','脉迟','脉涩','脉弱','脉虚','脉濡','脉缓','脉紧','洪脉','实脉','促脉','代脉','动脉','短脉','伏脉','革脉','疾脉','结脉','芤脉','散脉','牢脉','微脉','长脉']
        },
        {
            typeTitle: '合脉',
            list:['脉沉细','脉沉迟','脉沉弱','脉细数','脉细弱','脉弦滑','脉弦细','脉弦数','脉滑数','脉浮数']
        }
    ]
]
export const cssSelectList = {
    wcqk:[
        [
            {
                typeTitle: '母亲孕龄岁',
                list:[]
            },
            {
                typeTitle: '',
                list:[{value:'母亲孕龄24岁',label:'24'},{value:'母亲孕龄25岁',label:'25'},{value:'母亲孕龄26岁',label:'26'},{value:'母亲孕龄27岁',label:'27'},{value:'母亲孕龄28岁',label:'28'},{value:'母亲孕龄29岁',label:'29'},{value:'母亲孕龄30岁',label:'30'},{value:'母亲孕龄31岁',label:'31'},{value:'母亲孕龄32岁',label:'32'},{value:'母亲孕龄33岁',label:'33'},{value:'母亲孕龄34岁',label:'34'},{value:'母亲孕龄35岁',label:'35'}]
            }
        ],
        [
            {
                typeTitle: '孕周',
                list:[]
            },
            {
                typeTitle: '',
                list:[{value:'孕周小于37周',label:'小于37周'},{value:'孕周37',label:'37'},{value:'孕周38',label:'38'},{value:'孕周39',label:'39'},{value:'孕周40',label:'40'},{value:'孕周41',label:'41'},{value:'孕周42',label:'42'},{value:'孕周大于42周',label:'大于42周'}]
            }
        ],
        [
            {
                typeTitle: '产时并发症',
                list:[]
            },
            {
                typeTitle: '',
                list:[{value:'产时并发症子宫劈裂',label:'子宫劈裂'},{value:'产时并发症产后出血',label:'产后出血'},{value:'产时并发症胎膜早破',label:'胎膜早破'},{value:'产时并发症脐带异常',label:'脐带异常'},{value:'产时并发症羊水栓塞',label:'羊水栓塞'}]
            }
        ],
        [
            {
                typeTitle: '生产情况',
                list:[]
            },
            {
                typeTitle: '',
                list:[{value:'生产情况第1胎',label:'第1胎'},{value:'生产情况第2胎',label:'第2胎'},{value:'生产情况第3胎',label:'第3胎'},{value:'生产情况第4胎',label:'第4胎'},{value:'生产情况第5胎',label:'第5胎'},{value:'生产情况第6胎',label:'第6胎'}]
            },
            {
                typeTitle: '',
                list:[{value:'生产情况第1产',label:'第1产'},{value:'生产情况第2产',label:'第2产'},{value:'生产情况第3产',label:'第3产'},{value:'生产情况第4产',label:'第4产'},{value:'生产情况第5产',label:'第5产'},{value:'生产情况第6产',label:'第6产'}]
            },
            {
                typeTitle: '',
                list:[{value:'生产情况剖腹产',label:'剖腹产'},{value:'生产情况剖顺产',label:'顺产'}]
            }
        ],
    ],
    csqk:[
        [
            {
                typeTitle: '身长cm',
                list:[]
            },
            {
                typeTitle: '',
                list:[{value:'身长37cm',label:'37'},{value:'身长40cm',label:'40'},{value:'身长43cm',label:'43'},{value:'身长45cm',label:'45'},{value:'身长47cm',label:'47'},{value:'身长50cm',label:'50'},{value:'身长53cm',label:'53'},{value:'身长55cm',label:'55'},{value:'身长57cm',label:'57'},{value:'身长60cm',label:'60'},{value:'身长63cm',label:'63'}]
            }
        ],
        [
            {
                typeTitle: '体重kg',
                list:[]
            },
            {
                typeTitle: '',
                list:[{value:'体重2kg',label:'2'},{value:'体重2.5kg',label:'2.5'},{value:'体重3kg',label:'3.5'},{value:'体重4kg',label:'4'},{value:'体重4.5kg',label:'4.5'},{value:'体重5kg',label:'5'},{value:'体重5.5kg',label:'5.5'},{value:'体重6kg',label:'6'}]
            }
        ],
        [
            {
                typeTitle: '头围cm',
                list:[]
            },
            {
                typeTitle: '',
                list:[{value:'头围25cm',label:'25'},{value:'头围27cm',label:'27'},{value:'头围30cm',label:'30'},{value:'头围33cm',label:'33'},{value:'头围35cm',label:'35'},{value:'头围37cm',label:'40'},{value:'头围43cm',label:'43'},{value:'头围45cm',label:'45'},{value:'头围47cm',label:'47'},{value:'头围50cm',label:'50'}]
            }
        ],
        [
            {
                typeTitle: '出生情况',
                list:[]
            },
            {
                typeTitle: '',
                list:[{value:'出生情况听力正常',label:'听力正常'},{value:'出生情况听力迟缓',label:'听力迟缓'},]
            },
            {
                typeTitle: '',
                list:[{value:'出生情况视力正常',label:'视力正常'},{value:'出生情况视力迟缓',label:'视力迟缓'},]
            },
            {
                typeTitle: '',
                list:[{value:'出生情况窒息抢救',label:'窒息抢救'},{value:'出生情况感染发热',label:'感染发热'},{value:'出生情况畸形出血',label:'畸形出血'}]
            }
        ],
    ],
}
export const tgjcSelectList = {
    tz: [
        [
            {
                typeTitle: null,
                list:['生命体征平稳','神志清楚','精神反应尚可','未见皮疹','浅表淋巴结未扪及肿大','双肺呼吸音清晰']
            },
            {
                typeTitle: null,
                list:['双肺叩诊呈清音','未闻及异常呼吸音及干湿啰音','未闻及心包摩擦音']
            },
            {
                typeTitle: null,
                list:['心前区无异常搏动','心音有力心律齐','各瓣膜区未闻及明显杂音']
            },
            {
                typeTitle: null,
                list:['腹部柔软','无腹肌紧张','全腹部无压痛','肠鸣音活跃','双肾区无叩痛']
            },
        ]
    ],
    tw: [
        [
            {
                typeTitle: null,
                list:[
                    {value:'体温36.0°C',label:'36.0°C'},
                    {value:'体温36.5°C',label:'36.5°C'},
                    {value:'体温37.0°C',label:'37.0°C'},
                    {value:'体温37.3°C',label:'37.3°C'},
                    {value:'体温37.4°C',label:'37.4°C'},
                    {value:'体温37.5°C',label:'37.5°C'},
                    {value:'体温37.6°C',label:'37.6°C'},
                    {value:'体温37.7°C',label:'37.7°C'},
                    {value:'体温37.8°C',label:'37.8°C'},
                    {value:'体温37.9°C',label:'37.9°C'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'体温38.0°C',label:'38.0°C'},
                    {value:'体温38.1°C',label:'38.1°C'},
                    {value:'体温38.2°C',label:'38.2°C'},
                    {value:'体温38.3°C',label:'38.3°C'},
                    {value:'体温38.4°C',label:'38.4°C'},
                    {value:'体温38.5°C',label:'38.5°C'},
                    {value:'体温38.6°C',label:'38.6°C'},
                    {value:'体温38.7°C',label:'38.7°C'},
                    {value:'体温38.8°C',label:'38.8°C'},
                    {value:'体温38.9°C',label:'38.9°C'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'体温39.0°C',label:'39.0°C'},
                    {value:'体温39.1°C',label:'39.1°C'},
                    {value:'体温39.2°C',label:'39.2°C'},
                    {value:'体温39.3°C',label:'39.3°C'},
                    {value:'体温39.4°C',label:'39.4°C'},
                    {value:'体温39.5°C',label:'39.5°C'},
                    {value:'体温39.6°C',label:'39.6°C'},
                    {value:'体温39.7°C',label:'39.7°C'},
                    {value:'体温39.8°C',label:'39.8°C'},
                    {value:'体温39.9°C',label:'39.9°C'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'体温40.0°C',label:'40.0°C'},
                    {value:'体温40.1°C',label:'40.1°C'},
                    {value:'体温40.2°C',label:'40.2°C'},
                    {value:'体温40.3°C',label:'40.3°C'},
                    {value:'体温40.4°C',label:'40.4°C'},
                    {value:'体温40.5°C',label:'40.5°C'},
                    {value:'体温40.6°C',label:'40.6°C'},
                    {value:'体温40.7°C',label:'40.7°C'},
                    {value:'体温40.8°C',label:'40.8°C'},
                    {value:'体温40.9°C',label:'40.9°C'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'体温41.0°C',label:'41.0°C'},
                    {value:'体温41.1°C',label:'41.1°C'},
                    {value:'体温41.2°C',label:'41.2°C'},
                    {value:'体温41.3°C',label:'41.3°C'},
                    {value:'体温41.4°C',label:'41.4°C'},
                    {value:'体温41.5°C',label:'41.5°C'},
                    {value:'体温41.6°C',label:'41.6°C'},
                    {value:'体温41.7°C',label:'41.7°C'},
                    {value:'体温41.8°C',label:'41.8°C'},
                    {value:'体温41.9°C',label:'41.9°C'},
                ]
            },
        ]
    ],
    mb: [
        [
            {
                typeTitle: null,
                list:[
                    {value:'脉搏30bpm',label:'30'},
                    {value:'脉搏35bpm',label:'35'},
                    {value:'脉搏40bpm',label:'40'},
                    {value:'脉搏45bpm',label:'45'},
                    {value:'脉搏50bpm',label:'50'},
                    {value:'脉搏55bpm',label:'55'},
                    {value:'脉搏60bpm',label:'60'},
                    {value:'脉搏65bpm',label:'65'},
                    {value:'脉搏70bpm',label:'70'},
                    {value:'脉搏75bpm',label:'75'},
                    {value:'脉搏80bpm',label:'80'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'脉搏85bpm',label:'85'},
                    {value:'脉搏90bpm',label:'90'},
                    {value:'脉搏95bpm',label:'95'},
                    {value:'脉搏100bpm',label:'100'},
                    {value:'脉搏105bpm',label:'105'},
                    {value:'脉搏110bpm',label:'110'},
                    {value:'脉搏115bpm',label:'115'},
                    {value:'脉搏120bpm',label:'120'},
                    {value:'脉搏125bpm',label:'125'},
                    {value:'脉搏130bpm',label:'130'},
                    {value:'脉搏135bpm',label:'135'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'脉搏140bpm',label:'140'},
                    {value:'脉搏145bpm',label:'145'},
                    {value:'脉搏150bpm',label:'150'},
                    {value:'脉搏155bpm',label:'155'},
                    {value:'脉搏160bpm',label:'160'},
                    {value:'脉搏165bpm',label:'165'},
                    {value:'脉搏170bpm',label:'170'},
                    {value:'脉搏175bpm',label:'175'},
                    {value:'脉搏180bpm',label:'180'},
                ]
            },
        ]
    ],
    hx: [
        [
            {
                typeTitle: null,
                list:[
                    {value:'呼吸10次/分',label:'10'},
                    {value:'呼吸11次/分',label:'11'},
                    {value:'呼吸12次/分',label:'12'},
                    {value:'呼吸13次/分',label:'13'},
                    {value:'呼吸14次/分',label:'14'},
                    {value:'呼吸15次/分',label:'15'},
                    {value:'呼吸16次/分',label:'16'},
                    {value:'呼吸17次/分',label:'17'},
                    {value:'呼吸18次/分',label:'18'},
                    {value:'呼吸19次/分',label:'19'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'呼吸20次/分',label:'20'},
                    {value:'呼吸21次/分',label:'21'},
                    {value:'呼吸22次/分',label:'22'},
                    {value:'呼吸23次/分',label:'23'},
                    {value:'呼吸24次/分',label:'24'},
                    {value:'呼吸25次/分',label:'25'},
                    {value:'呼吸26次/分',label:'26'},
                    {value:'呼吸27次/分',label:'27'},
                    {value:'呼吸28次/分',label:'28'},
                    {value:'呼吸29次/分',label:'29'},
                ]
            },
            {
                typeTitle: null,
                list:[
                    {value:'呼吸30次/分',label:'30'},
                    {value:'呼吸31次/分',label:'31'},
                    {value:'呼吸32次/分',label:'32'},
                    {value:'呼吸33次/分',label:'33'},
                    {value:'呼吸34次/分',label:'34'},
                    {value:'呼吸35次/分',label:'35'},
                    {value:'呼吸36次/分',label:'36'},
                    {value:'呼吸37次/分',label:'37'},
                    {value:'呼吸38次/分',label:'38'},
                    {value:'呼吸39次/分',label:'39'},
                ]
            },
        ]
    ],
    xy: [
        [
            {
                typeTitle: '收缩压',
                list:['82','84','86','88','90','92','94','96','98','100','102','104','106','108','110','112','114','116','118','120','122','124','126','128','130','132','134','136','138','140','142','144','146','148','150','152','154','156','158','160','162','164','166','168','170','172','174','176','178','180']
            }
        ],
        [
            {
                typeTitle: '舒展压',
                list:['52','54','56','58','60','62','64','66','68','70','72','74','76','78','80','82','84','86','88','90','92','94','96','98','100','102','104','106','108','110']
            }
        ]
    ],
    tizhong1: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'体重2.0kg',label: '2.0'},
                    {value:'体重2.5kg',label: '2.5'},
                    {value:'体重3.0kg',label: '3.0'},
                    {value:'体重3.5kg',label: '3.5'},
                    {value:'体重4.0kg',label: '4.0'},
                    {value:'体重4.5kg',label: '4.5'},
                    {value:'体重5.0kg',label: '5.0'},
                    {value:'体重5.5kg',label: '5.5'},
                    {value:'体重6.0kg',label: '6.0'},
                    {value:'体重6.5kg',label: '6.5'},
                    {value:'体重7.0kg',label: '7.0'},
                    {value:'体重7.5kg',label: '7.5'},
                    {value:'体重8.0kg',label: '8.0'},
                    {value:'体重8.5kg',label: '8.5'},
                    {value:'体重9.0kg',label: '9.0'},
                    {value:'体重9.5kg',label: '9.5'},
                    {value:'体重10.0kg',label: '10.0'},
                    {value:'体重10.5kg',label: '10.5'},
                    {value:'体重11.0kg',label: '11.0'},
                    {value:'体重11.5kg',label: '11.5'},
                    {value:'体重12.0kg',label: '12.0'},
                    {value:'体重12.5kg',label: '12.5'},
                    {value:'体重13.0kg',label: '13.0'},
                    {value:'体重13.5kg',label: '13.5'},
                    {value:'体重14.0kg',label: '14.0'},
                    {value:'体重14.5kg',label: '14.5'},
                    {value:'体重15.0kg',label: '15.0'},
                    {value:'体重15.5kg',label: '15.5'},
                    {value:'体重16.0kg',label: '16.0'},
                    {value:'体重16.5kg',label: '16.5'},
                    {value:'体重17.0kg',label: '17.0'},
                    {value:'体重17.5kg',label: '17.5'},
                    {value:'体重18.0kg',label: '18.0'},
                    {value:'体重18.5kg',label: '18.5'},
                    {value:'体重19.0kg',label: '19.0'},
                    {value:'体重19.5kg',label: '19.5'},
                    {value:'体重20.0kg',label: '20.0'},
                    {value:'体重20.5kg',label: '20.5'},
                    {value:'体重21.0kg',label: '21.0'},
                    {value:'体重21.5kg',label: '21.5'},
                    {value:'体重22.0kg',label: '22.0'},
                    {value:'体重22.5kg',label: '22.5'},
                    {value:'体重23.0kg',label: '23.0'},
                    {value:'体重23.5kg',label: '23.5'},
                    {value:'体重24.0kg',label: '24.0'},
                    {value:'体重24.5kg',label: '24.5'},
                    {value:'体重25.0kg',label: '25.0'},
                    {value:'体重25.5kg',label: '25.5'},
                    {value:'体重26.0kg',label: '26.0'},
                    {value:'体重26.5kg',label: '26.5'},
                    {value:'体重27.0kg',label: '27.0'},
                    {value:'体重27.5kg',label: '27.5'},
                    {value:'体重28.0kg',label: '28.0'},
                    {value:'体重28.5kg',label: '28.5'},
                    {value:'体重29.0kg',label: '29.0'},
                    {value:'体重29.5kg',label: '29.5'},
                    {value:'体重30.0kg',label: '30.0'},
                    {value:'体重30.5kg',label: '30.5'},
                    {value:'体重31.0kg',label: '31.0'},
                    {value:'体重31.5kg',label: '31.5'},
                    {value:'体重32.0kg',label: '32.0'},
                ]
            }
        ]
    ],
    tizhong2: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'体重30.0kg',label: '30.0'},
                    {value:'体重30.5kg',label: '30.5'},
                    {value:'体重31.0kg',label: '31.0'},
                    {value:'体重31.5kg',label: '31.5'},
                    {value:'体重32.0kg',label: '32.0'},
                    {value:'体重32.5kg',label: '32.5'},
                    {value:'体重33.0kg',label: '33.0'},
                    {value:'体重33.5kg',label: '33.5'},
                    {value:'体重34.0kg',label: '34.0'},
                    {value:'体重34.5kg',label: '34.5'},
                    {value:'体重35.0kg',label: '35.0'},
                    {value:'体重35.5kg',label: '35.5'},
                    {value:'体重36.0kg',label: '36.0'},
                    {value:'体重36.5kg',label: '36.5'},
                    {value:'体重37.0kg',label: '37.0'},
                    {value:'体重37.5kg',label: '37.5'},
                    {value:'体重38.0kg',label: '38.0'},
                    {value:'体重38.5kg',label: '38.5'},
                    {value:'体重39.0kg',label: '39.0'},
                    {value:'体重39.5kg',label: '39.5'},
                    {value:'体重40.0kg',label: '40.0'},
                    {value:'体重40.5kg',label: '40.5'},
                    {value:'体重41.0kg',label: '41.0'},
                    {value:'体重41.5kg',label: '41.5'},
                    {value:'体重42.0kg',label: '42.0'},
                    {value:'体重42.5kg',label: '42.5'},
                    {value:'体重43.0kg',label: '43.0'},
                    {value:'体重43.5kg',label: '43.5'},
                    {value:'体重44.0kg',label: '44.0'},
                    {value:'体重44.5kg',label: '44.5'},
                    {value:'体重45.0kg',label: '45.0'},
                    {value:'体重45.5kg',label: '45.5'},
                    {value:'体重46.0kg',label: '46.0'},
                    {value:'体重46.5kg',label: '46.5'},
                    {value:'体重47.0kg',label: '47.0'},
                    {value:'体重47.5kg',label: '47.5'},
                    {value:'体重48.0kg',label: '48.0'},
                    {value:'体重48.5kg',label: '48.5'},
                    {value:'体重49.0kg',label: '49.0'},
                    {value:'体重49.5kg',label: '49.5'},
                    {value:'体重50.0kg',label: '50.0'},
                    {value:'体重50.5kg',label: '50.5'},
                    {value:'体重51.0kg',label: '51.0'},
                    {value:'体重51.5kg',label: '51.5'},
                    {value:'体重52.0kg',label: '52.0'},
                    {value:'体重52.5kg',label: '52.5'},
                    {value:'体重53.0kg',label: '53.0'},
                    {value:'体重53.5kg',label: '53.5'},
                    {value:'体重54.0kg',label: '54.0'},
                    {value:'体重54.5kg',label: '54.5'},
                    {value:'体重55.0kg',label: '55.0'},
                    {value:'体重55.5kg',label: '55.5'},
                    {value:'体重56.0kg',label: '56.0'},
                    {value:'体重56.5kg',label: '56.5'},
                    {value:'体重57.0kg',label: '57.0'},
                    {value:'体重57.5kg',label: '57.5'},
                    {value:'体重58.0kg',label: '58.0'},
                    {value:'体重58.5kg',label: '58.5'},
                    {value:'体重59.0kg',label: '59.0'},
                    {value:'体重59.5kg',label: '59.5'},
                    {value:'体重60.0kg',label: '60.0'},
                ]
            }
        ]
    ],
    tizhong3: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'体重45kg',label: '45'},
                    {value:'体重46kg',label: '46'},
                    {value:'体重47kg',label: '47'},
                    {value:'体重48kg',label: '48'},
                    {value:'体重49kg',label: '49'},
                    {value:'体重50kg',label: '50'},
                    {value:'体重51kg',label: '51'},
                    {value:'体重52kg',label: '52'},
                    {value:'体重53kg',label: '53'},
                    {value:'体重54kg',label: '54'},
                    {value:'体重55kg',label: '55'},
                    {value:'体重56kg',label: '56'},
                    {value:'体重57kg',label: '57'},
                    {value:'体重58kg',label: '58'},
                    {value:'体重59kg',label: '59'},
                    {value:'体重60kg',label: '60'},
                    {value:'体重61kg',label: '61'},
                    {value:'体重62kg',label: '62'},
                    {value:'体重63kg',label: '63'},
                    {value:'体重64kg',label: '64'},
                    {value:'体重65kg',label: '65'},
                    {value:'体重66kg',label: '66'},
                    {value:'体重67kg',label: '67'},
                    {value:'体重68kg',label: '68'},
                    {value:'体重69kg',label: '69'},
                    {value:'体重70kg',label: '70'},
                    {value:'体重71kg',label: '71'},
                    {value:'体重72kg',label: '72'},
                    {value:'体重73kg',label: '73'},
                    {value:'体重74kg',label: '74'},
                    {value:'体重75kg',label: '75'},
                    {value:'体重76kg',label: '76'},
                    {value:'体重77kg',label: '77'},
                    {value:'体重78kg',label: '78'},
                    {value:'体重79kg',label: '79'},
                    {value:'体重80kg',label: '80'},
                    {value:'体重81kg',label: '81'},
                    {value:'体重82kg',label: '82'},
                    {value:'体重83kg',label: '83'},
                    {value:'体重84kg',label: '84'},
                    {value:'体重85kg',label: '85'},
                    {value:'体重86kg',label: '86'},
                    {value:'体重87kg',label: '87'},
                    {value:'体重88kg',label: '88'},
                    {value:'体重89kg',label: '89'},
                    {value:'体重90kg',label: '90'},
                    {value:'体重91kg',label: '91'},
                    {value:'体重92kg',label: '92'},
                    {value:'体重93kg',label: '93'},
                    {value:'体重94kg',label: '94'},
                    {value:'体重95kg',label: '95'},
                    {value:'体重96kg',label: '96'},
                    {value:'体重97kg',label: '97'},
                    {value:'体重98kg',label: '98'},
                    {value:'体重99kg',label: '99'},
                    {value:'体重100kg',label: '100'},
                ]
            }
        ]
    ],
    shengao1: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'身高45cm',label: '45'},
                    {value:'身高46cm',label: '46'},
                    {value:'身高47cm',label: '47'},
                    {value:'身高48cm',label: '48'},
                    {value:'身高49cm',label: '49'},
                    {value:'身高50cm',label: '50'},
                    {value:'身高51cm',label: '51'},
                    {value:'身高52cm',label: '52'},
                    {value:'身高53cm',label: '53'},
                    {value:'身高54cm',label: '54'},
                    {value:'身高55cm',label: '55'},
                    {value:'身高56cm',label: '56'},
                    {value:'身高57cm',label: '57'},
                    {value:'身高58cm',label: '58'},
                    {value:'身高59cm',label: '59'},
                    {value:'身高60cm',label: '60'},
                    {value:'身高61cm',label: '61'},
                    {value:'身高62cm',label: '62'},
                    {value:'身高63cm',label: '63'},
                    {value:'身高64cm',label: '64'},
                    {value:'身高65cm',label: '65'},
                    {value:'身高66cm',label: '66'},
                    {value:'身高67cm',label: '67'},
                    {value:'身高68cm',label: '68'},
                    {value:'身高69cm',label: '69'},
                    {value:'身高70cm',label: '70'},
                    {value:'身高71cm',label: '71'},
                    {value:'身高72cm',label: '72'},
                    {value:'身高73cm',label: '73'},
                    {value:'身高74cm',label: '74'},
                    {value:'身高75cm',label: '75'},
                    {value:'身高76cm',label: '76'},
                    {value:'身高77cm',label: '77'},
                    {value:'身高78cm',label: '78'},
                    {value:'身高79cm',label: '79'},
                    {value:'身高80cm',label: '80'},
                    {value:'身高81cm',label: '81'},
                    {value:'身高82cm',label: '82'},
                    {value:'身高83cm',label: '83'},
                    {value:'身高84cm',label: '84'},
                    {value:'身高85cm',label: '85'},
                    {value:'身高86cm',label: '86'},
                    {value:'身高87cm',label: '87'},
                    {value:'身高88cm',label: '88'},
                    {value:'身高89cm',label: '89'},
                    {value:'身高90cm',label: '90'},
                    {value:'身高91cm',label: '91'},
                    {value:'身高92cm',label: '92'},
                    {value:'身高93cm',label: '93'},
                    {value:'身高94cm',label: '94'},
                    {value:'身高95cm',label: '95'},
                    {value:'身高96cm',label: '96'},
                    {value:'身高97cm',label: '97'},
                    {value:'身高98cm',label: '98'},
                    {value:'身高99cm',label: '99'},
                    {value:'身高100cm',label: '100'},
                ]
            }
        ]
    ],
    shengao2: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'身高100cm',label: '100'},
                    {value:'身高101cm',label: '101'},
                    {value:'身高102cm',label: '102'},
                    {value:'身高103cm',label: '103'},
                    {value:'身高104cm',label: '104'},
                    {value:'身高105cm',label: '105'},
                    {value:'身高106cm',label: '106'},
                    {value:'身高107cm',label: '107'},
                    {value:'身高108cm',label: '108'},
                    {value:'身高109cm',label: '109'},
                    {value:'身高110cm',label: '110'},
                    {value:'身高111cm',label: '111'},
                    {value:'身高112cm',label: '112'},
                    {value:'身高113cm',label: '113'},
                    {value:'身高114cm',label: '114'},
                    {value:'身高115cm',label: '115'},
                    {value:'身高116cm',label: '116'},
                    {value:'身高117cm',label: '117'},
                    {value:'身高118cm',label: '118'},
                    {value:'身高119cm',label: '119'},
                    {value:'身高120cm',label: '120'},
                    {value:'身高121cm',label: '121'},
                    {value:'身高122cm',label: '122'},
                    {value:'身高123cm',label: '123'},
                    {value:'身高124cm',label: '124'},
                    {value:'身高125cm',label: '125'},
                    {value:'身高126cm',label: '126'},
                    {value:'身高127cm',label: '127'},
                    {value:'身高128cm',label: '128'},
                    {value:'身高129cm',label: '129'},
                    {value:'身高130cm',label: '130'},
                    {value:'身高131cm',label: '131'},
                    {value:'身高132cm',label: '132'},
                    {value:'身高133cm',label: '133'},
                    {value:'身高134cm',label: '134'},
                    {value:'身高135cm',label: '135'},
                    {value:'身高136cm',label: '136'},
                    {value:'身高137cm',label: '137'},
                    {value:'身高138cm',label: '138'},
                    {value:'身高139cm',label: '139'},
                    {value:'身高140cm',label: '140'},
                    {value:'身高141cm',label: '141'},
                    {value:'身高142cm',label: '142'},
                    {value:'身高143cm',label: '143'},
                    {value:'身高144cm',label: '144'},
                    {value:'身高145cm',label: '145'},
                    {value:'身高146cm',label: '146'},
                    {value:'身高147cm',label: '147'},
                    {value:'身高148cm',label: '148'},
                    {value:'身高149cm',label: '149'},
                    {value:'身高150cm',label: '150'},
                ]
            }
        ]
    ],
    shengao3: [
        [
            {
                typeTitle: '',
                list:[
                    {value:'身高150cm',label: '150'},
                    {value:'身高151cm',label: '151'},
                    {value:'身高152cm',label: '152'},
                    {value:'身高153cm',label: '153'},
                    {value:'身高154cm',label: '154'},
                    {value:'身高155cm',label: '155'},
                    {value:'身高156cm',label: '156'},
                    {value:'身高157cm',label: '157'},
                    {value:'身高158cm',label: '158'},
                    {value:'身高159cm',label: '159'},
                    {value:'身高160cm',label: '160'},
                    {value:'身高161cm',label: '161'},
                    {value:'身高162cm',label: '162'},
                    {value:'身高163cm',label: '163'},
                    {value:'身高164cm',label: '164'},
                    {value:'身高165cm',label: '165'},
                    {value:'身高166cm',label: '166'},
                    {value:'身高167cm',label: '167'},
                    {value:'身高168cm',label: '168'},
                    {value:'身高169cm',label: '169'},
                    {value:'身高170cm',label: '170'},
                    {value:'身高171cm',label: '171'},
                    {value:'身高172cm',label: '172'},
                    {value:'身高173cm',label: '173'},
                    {value:'身高174cm',label: '174'},
                    {value:'身高175cm',label: '175'},
                    {value:'身高176cm',label: '176'},
                    {value:'身高177cm',label: '177'},
                    {value:'身高178cm',label: '178'},
                    {value:'身高179cm',label: '179'},
                    {value:'身高180cm',label: '180'},
                    {value:'身高181cm',label: '181'},
                    {value:'身高182cm',label: '182'},
                    {value:'身高183cm',label: '183'},
                    {value:'身高184cm',label: '184'},
                    {value:'身高185cm',label: '185'},
                    {value:'身高186cm',label: '186'},
                    {value:'身高187cm',label: '187'},
                    {value:'身高188cm',label: '188'},
                    {value:'身高189cm',label: '189'},
                    {value:'身高190cm',label: '190'},
                    {value:'身高191cm',label: '191'},
                    {value:'身高192cm',label: '192'},
                    {value:'身高193cm',label: '193'},
                    {value:'身高194cm',label: '194'},
                    {value:'身高195cm',label: '195'},
                    {value:'身高196cm',label: '196'},
                    {value:'身高197cm',label: '197'},
                    {value:'身高198cm',label: '198'},
                    {value:'身高199cm',label: '199'},
                    {value:'身高200cm',label: '200'},
                ]
            }
        ]
    ],
    xueyang:[
        [
            {
                typeTitle: null,
                list:[
                    {value:'血氧70%',label:'70'},
                    {value:'血氧71%',label:'71'},
                    {value:'血氧72%',label:'72'},
                    {value:'血氧73%',label:'73'},
                    {value:'血氧74%',label:'74'},
                    {value:'血氧75%',label:'75'},
                    {value:'血氧76%',label:'76'},
                    {value:'血氧77%',label:'77'},
                    {value:'血氧78%',label:'78'},
                    {value:'血氧79%',label:'79'},
                    {value:'血氧80%',label:'80'},
                    {value:'血氧81%',label:'81'},
                    {value:'血氧82%',label:'82'},
                    {value:'血氧83%',label:'83'},
                    {value:'血氧84%',label:'84'},
                    {value:'血氧85%',label:'85'},
                    {value:'血氧86%',label:'86'},
                    {value:'血氧87%',label:'87'},
                    {value:'血氧88%',label:'88'},
                    {value:'血氧89%',label:'89'},
                    {value:'血氧90%',label:'90'},
                    {value:'血氧91%',label:'91'},
                    {value:'血氧92%',label:'92'},
                    {value:'血氧93%',label:'93'},
                    {value:'血氧94%',label:'94'},
                    {value:'血氧95%',label:'95'},
                    {value:'血氧96%',label:'96'},
                    {value:'血氧97%',label:'97'},
                    {value:'血氧98%',label:'98'},
                    {value:'血氧99%',label:'99'},
                ]
            }
        ]
    ],
    xuetang:[
        [
            {
                typeTitle: null,
                list:[
                    {value:'血糖4.0mmol/L',label:'4.0'},
                    {value:'血糖4.1mmol/L',label:'4.1'},
                    {value:'血糖4.2mmol/L',label:'4.2'},
                    {value:'血糖4.3mmol/L',label:'4.3'},
                    {value:'血糖4.4mmol/L',label:'4.4'},
                    {value:'血糖4.5mmol/L',label:'4.5'},
                    {value:'血糖4.6mmol/L',label:'4.6'},
                    {value:'血糖4.7mmol/L',label:'4.7'},
                    {value:'血糖4.8mmol/L',label:'4.8'},
                    {value:'血糖4.9mmol/L',label:'4.9'},
                    {value:'血糖5.0mmol/L',label:'5.0'},
                    {value:'血糖5.1mmol/L',label:'5.1'},
                    {value:'血糖5.2mmol/L',label:'5.2'},
                    {value:'血糖5.3mmol/L',label:'5.3'},
                    {value:'血糖5.4mmol/L',label:'5.4'},
                    {value:'血糖5.5mmol/L',label:'5.5'},
                    {value:'血糖5.6mmol/L',label:'5.6'},
                    {value:'血糖5.7mmol/L',label:'5.7'},
                    {value:'血糖5.8mmol/L',label:'5.8'},
                    {value:'血糖5.9mmol/L',label:'5.9'},
                    {value:'血糖6.0mmol/L',label:'6.0'},
                    {value:'血糖6.1mmol/L',label:'6.1'},
                    {value:'血糖6.2mmol/L',label:'6.2'},
                    {value:'血糖6.3mmol/L',label:'6.3'},
                    {value:'血糖6.4mmol/L',label:'6.4'},
                    {value:'血糖6.5mmol/L',label:'6.5'},
                    {value:'血糖6.6mmol/L',label:'6.6'},
                    {value:'血糖6.7mmol/L',label:'6.7'},
                    {value:'血糖6.8mmol/L',label:'6.8'},
                    {value:'血糖6.9mmol/L',label:'6.9'},
                    {value:'血糖7.0mmol/L',label:'7.0'},
                    {value:'血糖7.1mmol/L',label:'7.1'},
                    {value:'血糖7.2mmol/L',label:'7.2'},
                    {value:'血糖7.3mmol/L',label:'7.3'},
                    {value:'血糖7.4mmol/L',label:'7.4'},
                    {value:'血糖7.5mmol/L',label:'7.5'},
                    {value:'血糖7.6mmol/L',label:'7.6'},
                    {value:'血糖7.7mmol/L',label:'7.7'},
                    {value:'血糖7.8mmol/L',label:'7.8'},
                    {value:'血糖7.9mmol/L',label:'7.9'},
                    {value:'血糖8.0mmol/L',label:'8.0'},
                    {value:'血糖8.1mmol/L',label:'8.1'},
                    {value:'血糖8.2mmol/L',label:'8.2'},
                    {value:'血糖8.3mmol/L',label:'8.3'},
                    {value:'血糖8.4mmol/L',label:'8.4'},
                    {value:'血糖8.5mmol/L',label:'8.5'},
                    {value:'血糖8.6mmol/L',label:'8.6'},
                    {value:'血糖8.7mmol/L',label:'8.7'},
                    {value:'血糖8.8mmol/L',label:'8.8'},
                    {value:'血糖8.9mmol/L',label:'8.9'},
                    {value:'血糖9.0mmol/L',label:'9.0'},
                    {value:'血糖9.1mmol/L',label:'9.1'},
                    {value:'血糖9.2mmol/L',label:'9.2'},
                    {value:'血糖9.3mmol/L',label:'9.3'},
                    {value:'血糖9.4mmol/L',label:'9.4'},
                    {value:'血糖9.5mmol/L',label:'9.5'},
                    {value:'血糖9.6mmol/L',label:'9.6'},
                    {value:'血糖9.7mmol/L',label:'9.7'},
                    {value:'血糖9.8mmol/L',label:'9.8'},
                    {value:'血糖9.9mmol/L',label:'9.9'},
                    {value:'血糖10.0mmol/L',label:'10.0'},
                    {value:'血糖10.2mmol/L',label:'10.2'},
                    {value:'血糖10.4mmol/L',label:'10.4'},
                    {value:'血糖10.6mmol/L',label:'10.6'},
                    {value:'血糖10.8mmol/L',label:'10.8'},
                    {value:'血糖11.0mmol/L',label:'11.0'},
                    {value:'血糖11.2mmol/L',label:'11.2'},
                    {value:'血糖11.4mmol/L',label:'11.4'},
                    {value:'血糖11.6mmol/L',label:'11.6'},
                    {value:'血糖11.8mmol/L',label:'11.8'},
                ]
            }
        ]
    ]
}
export const kqjcSelectList = {
  yazhou:[
        [
            {
                typeTitle: null,
                list:['牙龈苍白','牙龈暗红','牙龈鲜红','扪痛（-）','扪痛（+）']
            },
            {
                typeTitle: null,
                list:['牙龈红肿','牙龈脓肿','牙龈糜烂','牙龈出血','牙龈增生']
            },
            {
                typeTitle: null,
                list:['牙龈萎缩','点彩消失','无龈袋','有龈袋','牙周袋≤4mm','牙周袋≤6mm','牙周袋＞6mm']
            },
            {
                typeTitle: null,
                list:['牙结石（-）','牙结石（+）','牙结石（++）','牙结石（+++）','牙周袋附着丧失1~2mm']
            },
            {
                typeTitle: null,
                list:['牙周袋附着丧失3~4mm','牙周袋附着丧失≥5mm']
            },
        ],
      [
          {
              typeTitle: null,
              list:['口腔粘膜苍白','口腔粘膜暗红']
          },
          {
              typeTitle: null,
              list:['口腔粘膜鲜红','口腔粘膜疱疹','口腔粘膜丘疹']
          },
          {
              typeTitle: null,
              list:['口腔粘膜溃疡','口腔粘膜瘢痕','口腔粘膜角化']
          },
      ],
    ],
    sheexian:[
        [
            {
                typeTitle: null,
                list:['舌体裂纹','舌体溃疡','舌体肿胀','舌乳头异常','苔黄','苔灰黑','苔厚','苔少','无苔']
            }
        ],
        [
            {
                typeTitle: null,
                list:['软腭充血','软腭角化','软腭溃疡','软腭痿管','软腭运动障碍','硬腭充血','硬腭角化','硬腭溃疡','硬腭痿管']
            }
        ],
        [
            {
                typeTitle: null,
                list:['腮腺导管口肿胀','腮腺导管口压痛','腮腺导管口阻塞','腮腺导管口充血','腮腺导管口溢脓','下颌下腺导管口肿胀','下颌下腺导管口压痛','下颌下腺导管口阻塞','下颌下腺导管口溢脓']
            }
        ]
    ],
    ehemian:[
        [
            {
                typeTitle: null,
                list:['面部突出','面部凹陷','面部缺损','面部肿胀','面部痿管','面部不对称','面色萎黄','面色苍白','面色晦暗','面部瘢痕','面肌弛缓','面部麻木','面部疼痛','口角歪斜','眼角歪斜','眼睑下垂',
                    '眼球突出','鼻部畸形']
            }
        ],
        [
            {
                typeTitle: null,
                list:['上颌压痛','上颌囊肿','上颌前突','上颌后缩','上颌缺损','上颌骨折','上颌不对称','下颌囊肿','下颌前突','下颌后缩','下颌压痛','下颌缺损','下颌骨折','下颌不对称']
            }
        ],
        [
            {
                typeTitle: null,
                list:['左颞颌关节肿胀','左颞颌关节疼痛','左颞颌关节压痛','左颞颌关节弹响','右颞颌关节肿胀','右颞颌关节弹响']
            }
        ]
    ],
    linbajie:[
        [
            {
                typeTitle: null,
                list:['耳前淋巴结肿大','耳前淋巴结压痛','耳前淋巴结增多','耳前淋巴结粘连','耳后淋巴结肿大','耳后淋巴结压痛','耳后淋巴结增多','耳后淋巴结粘连',
                    '枕后淋巴结肿大','枕后淋巴结压痛','枕后淋巴结增多','枕后淋巴结粘连','颌下淋巴结肿大','颌下淋巴结压痛','颌下淋巴结增多','颌下淋巴结粘连',
                    '颏下淋巴结肿大','颏下淋巴结压痛','颏下淋巴结增多','颏下淋巴结粘连','颈前淋巴结肿大','颈前淋巴结压痛','颈前淋巴结增多','颈前淋巴结粘连','颈后淋巴结肿大','颈后淋巴结压痛','颈后淋巴结增多','颈后淋巴结粘连','锁骨上淋巴结肿大','锁骨上淋巴结压痛','锁骨上淋巴结增多','锁骨上淋巴结粘连']
            }
        ]
    ]
}
